import { ILibraryDocument } from '../libraryDocuments.types'
import config from '../../../config'

const generateDocUrl = (doc: Pick<ILibraryDocument, 'id' | 'fileName'>, token: string) => {
  return `${config.API_URL}/nsi/v1/library/documents/${doc?.id}/raw/${doc?.fileName}?accessToken=${token}`
}

const documentUrlService = { generateDocUrl }
export default documentUrlService
